export const emergencyRouteDef = [ 
    {
        path: ':resource/:id/:action',
        component:'SearchEngineComponent',
        data : {
            selector: 'app-search-engine'
        }
    }
]    
